import { AppliedBillableConceptEntityType, SumPerAccountingUnitResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { ValuableConceptsTreeNodeStructure } from '@/components/valuable-concepts-modal/valuable-concepts-modal-tree/valuable-concepts-modal-tree.model'
import { StrictNullable } from '@/shared/types/app.types'

export interface ValuableConceptsShowingPropertiesEntitySelected {
    entityId: number
    entityType: AppliedBillableConceptEntityType
}

export interface ValuableConceptsShowingProperties {
    isBillingModule: boolean
    caseId: number
    accountingId?: number
    entityConcept?: ValuableConceptsShowingPropertiesEntitySelected
    caseState?: string
}

export interface ValuableConceptsModalState {
    isDirty: boolean
    promise: StrictNullable<Promise<void>>
    activeTab: number
    accountingUnits: StrictNullable<SumPerAccountingUnitResponse[]>
    caseId: StrictNullable<number>
    selectedAccountingUnit: StrictNullable<SumPerAccountingUnitResponse>
    selectedNodeTree: StrictNullable<ValuableConceptsTreeNodeStructure>
    initialSelectedNodeTree: StrictNullable<ValuableConceptsShowingPropertiesEntitySelected>
    isBillingModule: boolean
    caseStatus: StrictNullable<string>
}
export const initialValuableConceptsModalState =
    (): ValuableConceptsModalState => ({
        isDirty: false,
        promise: null,
        activeTab: 0,
        accountingUnits: [],
        caseId: null,
        selectedAccountingUnit: null,
        selectedNodeTree: null,
        initialSelectedNodeTree: null,
        isBillingModule: false,
        caseStatus: null
    })
